export default __webpack_public_path__ + "media/zurb/img/events/soapbox/soapbox-img1-3f1b5cff5749180ea157f227b1140c50.png";